import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, BookOpen, Package, UtensilsCrossed, MoreHorizontal, Users, Globe } from "lucide-react";
import { usePlanFeatures } from "../hooks/usePlanFeatures";

// Labels homologados con los nombres del Sidebar agrupado (módulos 143-144):
// Sidebar → "Dashboard" (grupo "Inicio") / "Carta y platos" / "Recetas y escandallo" / "Inventario"
// En el bottom nav usamos el primer término (o el nombre de grupo) para que quepa en 1 línea.
const FULL_TABS = [
  { path: "/app", icon: LayoutDashboard, label: "Inicio", exact: true },
  { path: "/app/menus", icon: BookOpen, label: "Carta" },
  { path: "/app/recipes", icon: UtensilsCrossed, label: "Recetas" },
  { path: "/app/inventory", icon: Package, label: "Inventario" },
];

// Labels homologados con los nombres del Sidebar agrupado (módulos 143-144):
// Sidebar → "Clientes y fidelización" / "Carta y platos" / "Recetas y escandallo" / "Página web"
// En el bottom nav usamos el primer término de cada grupo para que quepa en 1 línea.
const STARTER_TABS = [
  { path: "/app/customers", icon: Users, label: "Clientes" },
  { path: "/app/menus", icon: BookOpen, label: "Carta" },
  { path: "/app/recipes", icon: UtensilsCrossed, label: "Recetas" },
  { path: "/app/website", icon: Globe, label: "Web" },
];

export function MobileBottomNav({ onMoreClick }) {
  const location = useLocation();
  const { planId } = usePlanFeatures();
  const tabs = planId === "plan_starter" ? STARTER_TABS : FULL_TABS;
  const isActive = (path, exact) => exact ? location.pathname === path : location.pathname.startsWith(path);

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 bg-card/95 backdrop-blur-xl border-t border-border lg:hidden" /* z-stack-doc: L4 mobile bottom navigation, coexists with FloatingOnboarding */
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-14">
        {tabs.map(tab => {
          const active = isActive(tab.path, tab.exact);
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                active ? "text-primary" : "text-muted-foreground"
              }`}
              data-testid={`btmnav-${tab.label.toLowerCase()}`}
            >
              <tab.icon className="w-5 h-5" strokeWidth={active ? 2.5 : 1.8} />
              <span className="text-[10px] font-medium leading-none">{tab.label}</span>
            </Link>
          );
        })}
        <button
          onClick={onMoreClick}
          className="flex flex-col items-center justify-center flex-1 h-full gap-0.5 text-muted-foreground"
          data-testid="btmnav-more"
        >
          <MoreHorizontal className="w-5 h-5" strokeWidth={1.8} />
          <span className="text-[10px] font-medium leading-none">Mas</span>
        </button>
      </div>
    </nav>
  );
}
